import React, { useState } from "react";
import { postUser } from "../../routing/routes";
import { useHistory } from "react-router-dom";

const NewUser = ({ users, roles, refreshData, setNotification }) => {
  return (
    <NewUserFrame
      Users={users}
      refreshData={refreshData}
      roles={roles}
      setNotification={setNotification}
    />
  );
};

const NewUserFrame = ({ Users, refreshData, roles, setNotification }) => {
  const history = useHistory();
  const [UserParams, setUserParams] = useState({
    username: "",
    password: "",
    cpassword: "",
    rol: "",
  });

  return (
    <div style={{ width: "80%", margin: "40px auto" }}>
      <div align="right">
        <div className="taby">Nuevo Usuario</div>
      </div>
      <div className="form-container">
        <h3> Nombre del Usuario </h3>
        <input
          onChange={(event) =>
            setUserParams({ ...UserParams, username: event.target.value })
          }
          style={{ width: "300px" }}
        ></input>
        <br />
        {!Users.every((e) => e.username !== UserParams.username) && (
          <span style={{ fontSize: 12, color: "red" }}>
            Ya existe el nombre de usuario
          </span>
        )}
        <h3> Selecciona un rol </h3>
        <select
          style={{ width: "320px" }}
          onChange={(event) =>
            setUserParams({ ...UserParams, rol: event.target.value })
          }
          value={UserParams.rol}
        >
          <option key="" value="">
            Selecciona un rol...
          </option>
          {roles.map((rol) => (
            <option key={rol} value={rol}>
              {rol}
            </option>
          ))}
        </select>
        <h3> Contraseña </h3>
        <input
          onChange={(event) =>
            setUserParams({ ...UserParams, password: event.target.value })
          }
          type="password"
          style={{ width: "80%" }}
        ></input>
        <br />
        <h3> Confirmar Contraseña </h3>
        <input
          onChange={(event) =>
            setUserParams({ ...UserParams, cpassword: event.target.value })
          }
          type="password"
          style={{ width: "80%" }}
        ></input>
        <br />
        {UserParams.password !== UserParams.cpassword && (
          <span style={{ fontSize: 12, color: "red" }}>
            Las contraseñas no coinciden
          </span>
        )}

        <br />
        <br />

        <div className="form-actions" align="right">
          {/* Boton para cancelar el registro de un usuario */}
          <button
            className="form-button secondary-button"
            onClick={() => history.push("/users")}
          >
            Cancelar
          </button>

          {/* Boton para guardar usuario */}
          <button
            disabled={
              UserParams.password !== UserParams.cpassword ||
              !UserParams.password ||
              !UserParams.username ||
              !UserParams.rol ||
              !Users.every((e) => e.username !== UserParams.username)
            } // !Users.every( e => e.username !== UserParams.username) <---- returns true if the user name already exists
            onClick={() =>
              Save(UserParams, history, refreshData, setNotification)
            }
            className="form-button primary-button"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  );
};

function Save(UserParams, history, refreshData, setNotification) {
  const { username, password, rol } = UserParams;
  const NewUser = { username, password, rol };
  postUser(NewUser)
    .catch((error) => {
      console.error("Error:", error);
      setNotification("eError al crear el usuario");
      history.push("/users");
    })
    .then(() => {
      refreshData();
      setNotification("mUsuario creado correctamente");
      history.push("/users");
    });
}

export default NewUser;
